import "./App.css";
import "./context-menu.css";
import "../node_modules/react-grid-layout/css/styles.css";
import "../node_modules/react-resizable/css/styles.css";
import "react-notifications-component/dist/theme.css";

import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import Amplify from "aws-amplify";
import awsconfig from "./awsConfig/awsConfig";

import cryptoCharts from "./assets/savedCharts/cryptoCharts2.json";

import MainPage from "./components/MainPage/MainPage";
import { addChartData } from "./redux/slices/chartData";

function App() {
  const dispatch = useDispatch();
  Amplify.configure(awsconfig);

  useEffect(() => {
    cryptoCharts.forEach(({ chart, interval, id, open }) => {
      dispatch(addChartData(chart, undefined, interval, id, true));
    });
  }, [dispatch]);

  return (
    <div>
      <MainPage />
    </div>
  );
}

export default App;
